/* ============================================================
   CULT RACING — WINNER SIGN-UP (cr-winner)
   The form a visitor reaches by escaping the OUTRUN game on a
   game-only page. Name and phone are required, because the drop
   password is sent by text on drop day; email is optional.

   Posts to the same Cloudflare proxy as every other Cult Racing
   form, with source "winner" and the drop handle, which the proxy
   turns into the tag `winner-<drop>` so each drop's winners are
   their own list in Omnisend.

   The SMS consent box is required here on purpose and is NOT
   pre-ticked: pre-checked consent fails Omnisend's toll-free
   verification, and without consent the proxy stores the number
   as nonSubscribed, which means no password text.
   ============================================================ */
(function () {
  "use strict";
  var form = document.getElementById("winnerForm");
  if (!form) return;
  var note = document.getElementById("winnerNote");
  var done = document.getElementById("winnerDone");
  var consent = document.getElementById("winnerConsent");
  var drop = form.getAttribute("data-drop") || "drop";

  function fail(msg) {
    if (note) note.textContent = msg;
    var btn = form.querySelector("button[type=submit]"); if (btn) btn.disabled = false;
  }

  form.addEventListener("submit", function (e) {
    e.preventDefault();
    var name = form.name.value.trim(), phone = form.phone.value.trim();
    if (!name || !phone || !(consent && consent.checked)) { form.reportValidity(); return; }
    if (phone.replace(/\D/g, "").length < 10) { form.phone.setCustomValidity("Enter a full phone number"); form.reportValidity(); form.phone.setCustomValidity(""); return; }
    var btn = form.querySelector("button[type=submit]");
    btn.disabled = true; if (note) note.textContent = "Locking it in...";
    fetch("https://cult-racing.pages.dev/api/join", {
      method: "POST", headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        name: name,
        phone: phone,
        email: (form.email && form.email.value || "").trim(),
        consent: true,
        company: form.company.value,   // honeypot
        source: "winner",
        drop: drop,
        // set only by an escape in cr-chase.js; lets the proxy mark real players
        played: (function () { try { return localStorage.getItem("cr-chase:" + drop) === "1"; } catch (e) { return false; } })()
      })
    }).then(function (r) { return r.json(); })
      .then(function (d) {
        if (d && d.ok) {
          form.hidden = true; if (done) done.hidden = false;
          try { document.dispatchEvent(new CustomEvent("cr:chase", { detail: { event: "chase_winner_signup" } })); } catch (err) {}
          if (window.dataLayer && window.dataLayer.push) window.dataLayer.push({ event: "chase_winner_signup" });
        } else fail("Something went wrong. Try again.");
      })
      .catch(function () { fail("Something went wrong. Try again."); });
  });
})();
